import {
  Component,
  EnvironmentInjector,
  HostListener,
  inject,
  NgZone,
  OnInit,
  runInInjectionContext
} from '@angular/core';
import {IonApp, IonContent, IonRouterOutlet} from '@ionic/angular/standalone';
import {
  accessibilityOutline,
  appsOutline,
  arrowBackOutline,
  arrowDownOutline,
  calendarOutline,
  chatboxEllipsesOutline,
  chevronBackOutline,
  chevronDownOutline,
  chevronExpandOutline,
  chevronForwardOutline,
  chevronUpOutline,
  closeCircleOutline,
  cloudUploadOutline,
  documentAttach,
  documentOutline,
  documentTextOutline,
  ellipsisVertical,
  eyeOffOutline,
  eyeOutline,
  helpBuoyOutline,
  home,
  hourglassOutline,
  layersOutline,
  logoIonic,
  logOut,
  peopleOutline,
  personCircle,
  personCircleOutline,
  rocketOutline,
  settings,
  settingsOutline,
} from 'ionicons/icons';
import { addIcons } from 'ionicons';
import { AuthStateService } from './services/auth-state.service';
import { CommonModule } from '@angular/common';
import { MobileBlockerComponent } from './components/mobile-blocker/mobile-blocker.component';
import { Messaging, onMessage } from '@angular/fire/messaging';
import { NotificationModalComponent } from './components/notification-modal/notification-modal.component';
import {Router} from "@angular/router";
import { AuthBrandIntroComponent } from './pages/auth/components/auth-brand-intro/auth-brand-intro.component';
import { ConnectionUnavailableScreenComponent } from './components/connection-unavailable-screen/connection-unavailable-screen.component';
import { ConnectionUnavailableScreenService } from './services/connection-unavailable-screen.service';
import { ServiceUnavailableScreenComponent } from './components/service-unavailable-screen/service-unavailable-screen.component';
import { ServiceUnavailableScreenService } from './services/service-unavailable-screen.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  imports: [
    IonApp,
    IonRouterOutlet,
    CommonModule,
    IonContent,
    MobileBlockerComponent,
    NotificationModalComponent,
    AuthBrandIntroComponent,
    ConnectionUnavailableScreenComponent,
    ServiceUnavailableScreenComponent,
  ],
  standalone: true,
})
export class AppComponent implements OnInit {
  isMobileBrowser = false;
  private messaging = inject(Messaging);
  private injector = inject(EnvironmentInjector);
  private router = inject(Router);
  protected readonly connectionUnavailableScreenService = inject(ConnectionUnavailableScreenService);
  protected readonly serviceUnavailableScreenService = inject(ServiceUnavailableScreenService);

  showNotificationModal = false;
  notificationTitle = '';
  notificationBody = '';
  notificationDocumentId: string | null = null;

  constructor(
    private authStateService: AuthStateService,
    private readonly ngZone: NgZone
  ) {
    addIcons({
      logoIonic,
      logOut,
      settings,
      home,
      personCircle,
      documentAttach,
      rocketOutline,
      peopleOutline,
      chevronBackOutline,
      layersOutline,
      appsOutline,
      personCircleOutline,
      documentTextOutline,
      chatboxEllipsesOutline,
      helpBuoyOutline,
      settingsOutline,
      accessibilityOutline,
      eyeOutline,
      eyeOffOutline,
      closeCircleOutline,
      calendarOutline,
      chevronExpandOutline,
      cloudUploadOutline,
      documentOutline,
      chevronUpOutline,
      chevronDownOutline,
      ellipsisVertical,
      arrowBackOutline,
      hourglassOutline,
      arrowDownOutline,
      chevronForwardOutline,
    });

    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.addEventListener('message', ({data}) => {
        if (data?.type === 'NAVIGATE' && typeof data.url === 'string') {
          this.ngZone.run(() => {
            if (data.url.startsWith('/')) this.router.navigateByUrl(data.url);
            else window.location.href = data.url;
          });
        }
      });
    }
  }

async ngOnInit(): Promise<void> {
    this.checkIfMobile();

    if (!this.isMobileBrowser) {
      const token = localStorage.getItem('accessToken');
      if (token) {
        await this.authStateService.fetchAuthenticatedUser();
      }
    }

    runInInjectionContext(this.injector, () => {
      onMessage(this.messaging, (payload) => {
        console.log('🔥 FCM Foreground Notification:', payload);


        const data = payload.data ?? {};
        const title = (payload.notification?.title ?? data['title'])?.trim() || '';
        const body = (payload.notification?.body ?? data['body'])?.trim() || '';

        if (!title && !body) {
          return;
        }

        this.ngZone.run(() => {
          this.showNotificationModal = true;
          this.notificationTitle = title;
          this.notificationBody = body;
          this.notificationDocumentId = payload.data?.['documentId'] || null;
        });
      });
    });
  }

  @HostListener('window:resize')
  onResize() {
    this.checkIfMobile();
  }

  checkIfMobile() {
    const userAgent =
      navigator.userAgent || navigator.vendor || (window as any).opera;
    const isMobile = /android|iphone|ipad|mobile/i.test(userAgent);
    const isNarrowScreen = window.innerWidth <= 768;
    this.isMobileBrowser = isMobile || isNarrowScreen;
  }
}
